import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Box from '@mui/material/Box'
import { Alert } from '@mui/material'

import { alertListSelector, AlertsActions } from 'primsell-shared-layer/features'

import { AlertTypeE } from 'primsell-shared-layer/types'

import { useStyles } from './alerts-wrapper.styles'
import { ReactComponent as CheckCircle } from 'primsell-shared-layer/assets/icons/check-circle.svg'
import { ReactComponent as Clocl3Icon } from 'primsell-shared-layer/assets/icons/clock3.svg'

const ICONS_CONFIG: Record<AlertTypeE, any> = {
  [AlertTypeE.SUCCESS]: <CheckCircle />,
  [AlertTypeE.WARNING]: undefined,
  [AlertTypeE.INFO]: <Clocl3Icon />,
  [AlertTypeE.ERROR]: undefined,
}

export const AlertsWrapper = () => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const alerts = useSelector(alertListSelector)

  const handleDeleteAlert = useCallback(
    (index: number) => {
      dispatch(AlertsActions.deleteAlert({ index }))
    },
    [dispatch]
  )

  useEffect(() => {
    const timeId = setTimeout(() => {
      if (alerts.length) {
        handleDeleteAlert(0)
      }

      return () => {
        clearTimeout(timeId)
      }
    }, 5000)
  }, [handleDeleteAlert, alerts])

  return (
    <Box className={classes.alertContainer}>
      {alerts.map((alert, index) => {
        return (
          <Alert
            key={`${alert.message}-${index}`}
            severity={alert.type}
            onClick={handleDeleteAlert.bind(null, index)}
            icon={ICONS_CONFIG[alert.type]}
          >
            {alert.message}
          </Alert>
        )
      })}
    </Box>
  )
}
